exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".typography_normal_OYarB {\r\n  font-weight: normal;\r\n}\r\n\r\n.typography_medium_3vRPs {\r\n  font-weight: 500;\r\n}\r\n\r\n.typography_light_tMnNG {\r\n  font-weight: 300;\r\n}\r\n\r\n.typography_body_FoH99 {\r\n  font-size: 13px;\r\n  font-weight: normal;\r\n}\r\n\r\n.typography_bodyMedium_Ry7xC {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n}\r\n\r\n.typography_title_3SBzk {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.typography_headline_C_PXc {\r\n  font-size: 24px;\r\n  font-weight: normal;\r\n  line-height: 32px;\r\n}\r\n\r\n.typography_subhead_3UXJu {\r\n  font-size: 15px;\r\n  font-weight: normal;\r\n}\r\n\r\n.typography_caption_25Syd {\r\n  font-size: 12px;\r\n  font-weight: normal;\r\n}\r\n\r\n.typography_display1_J-f96 {\r\n  font-size: 34px;\r\n  font-weight: normal;\r\n  line-height: 40px;\r\n}\r\n\r\n.typography_display2_1p7En {\r\n  font-size: 45px;\r\n  font-weight: normal;\r\n  line-height: 48px;\r\n}\r\n\r\n.typography_display3_2dy1a {\r\n  font-size: 56px;\r\n  font-weight: normal;\r\n}\r\n\r\n.typography_display4_3ljOm {\r\n  font-size: 112px;\r\n  font-weight: 300;\r\n}\r\n\r\n.typography_error_21wTi {\r\n  font-size: 12px;\r\n  font-weight: normal;\r\n  line-height: 12px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"normal": "typography_normal_OYarB",
	"medium": "typography_medium_3vRPs",
	"light": "typography_light_tMnNG",
	"body": "typography_body_FoH99",
	"bodyMedium": "typography_bodyMedium_Ry7xC",
	"title": "typography_title_3SBzk",
	"headline": "typography_headline_C_PXc",
	"subhead": "typography_subhead_3UXJu",
	"caption": "typography_caption_25Syd",
	"display1": "typography_display1_J-f96",
	"display2": "typography_display2_1p7En",
	"display3": "typography_display3_2dy1a",
	"display4": "typography_display4_3ljOm",
	"error": "typography_error_21wTi"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]_[local]_[hash:base64:5]!./src/styles/typography.css
// module id = 1154
// module chunks = 1